import { useSettingUpAnalyticsEvent } from '@/hooks/useSettingUpAnalytics'
import { useModalContext } from '../Modal/contexts/ModalContext'
import { SOSErrorModalProps } from './types'
import { Flex, getTheme, Modal, Space, Text } from '@conexasaude/conexa-hero'
import { useCallback, useEffect } from 'react'

export const SOSErrorModal = ({
  modalId,
  onOpenSOSModal,
}: SOSErrorModalProps) => {
  const theme = getTheme()
  const { closeModal, open } = useModalContext()

  const settingUpAnalyticsEvent = useSettingUpAnalyticsEvent()
  useEffect(() => {
    if (open !== modalId) return
    settingUpAnalyticsEvent({
      eventName: 'at_sos_mental_health_error_modal',
      interaction: 'seen',
    })
  }, [modalId, open, settingUpAnalyticsEvent])

  const handleAction = useCallback(() => {
    settingUpAnalyticsEvent({
      eventName: 'at_sos_mental_health_error_modal',
      interaction: 'request_again',
    })
    onOpenSOSModal()
  }, [onOpenSOSModal, settingUpAnalyticsEvent])

  return (
    <Modal
      primaryAction={handleAction}
      id={modalId}
      opened={open === modalId}
      onClose={closeModal}
      size={480}
      primaryActionLabel="Solicitar novamente"
      title="SOS Saúde Mental"
    >
      <Space mt={theme.spacing.sm} />
      <Flex direction="column">
        <Text variant="headingMedium">Por favor, tente novamente</Text>
        <Space mt={theme.spacing.xs} />

        <Text variant="paragraphLarge" fontWeight={700}>
          Não foi possível concluir a solicitação
        </Text>
        <Text variant="paragraphLarge">
          Mas não desista: envie um novo pedido!
        </Text>
        <Space mt={theme.spacing.xs} />
        <Text variant="paragraphLarge">
          Nossa função é te apoiar em situações como essa. Estamos trabalhando
          para consertar o erro!
        </Text>
      </Flex>
      <Space mt={theme.spacing.sm} />
    </Modal>
  )
}
